import { put, takeLatest, call, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { showLoader } from '../globalReducer';
import { apiErrorHandler } from '../Utils/apiErrorHandler';
import { chrApi, phrApi } from '../../api/api';
import {
  getMasterOrders,
  createPatientOrder,
  getMasterOrdersSuccess,
  getPatientOrdersById,
  getPatientOrdersByIdSuccess,
  updatePatientOrderById,
  getPatientDiagnosisById,
  getPatientDiagnosisByIdSuccess,
  geAppointmentOrdersById,
  geAppointmentOrdersByIdSuccess,
  handleNextOrderStep,
} from './slice';
import { activeOrdersSelector } from './selectors';

function fetchMasterOrdersApi() {
  return phrApi('get', 'order_display', null, null);
}
function* fetchMasterOrders(action) {
  try {
    yield put(showLoader(true));
    const { data } = yield call(fetchMasterOrdersApi, action.payload);
    yield put(showLoader(false));
    yield put(getMasterOrdersSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchMasterOrdersSaga() {
  yield takeLatest(getMasterOrders.type, fetchMasterOrders);
}

function postPatientOrderApi(data) {
  return chrApi('post', 'rx_order ', data, null);
}
function* postPatientOrder(action) {
  try {
    const data = yield select(activeOrdersSelector);
    yield put(showLoader(true));
    yield call(postPatientOrderApi, data);
    yield put(showLoader(false));
    toast.success('Orders Successfully Created');
    yield put(handleNextOrderStep());
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* postPatientOrderSaga() {
  yield takeLatest(createPatientOrder.type, postPatientOrder);
}

function putPatientOrderByIdApi() {
  return chrApi('put');
}
function* putPatientOrderById(action) {
  try {
    yield put(showLoader(true));
    yield call(putPatientOrderByIdApi, action.payload);
    yield put(showLoader(false));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* putPatientOrderByIdSaga() {
  yield takeLatest(updatePatientOrderById.type, putPatientOrderById);
}

function fetchPatientOrdersByIdApi(chrPatientId) {
  return chrApi('get', `rx_order/patient/${chrPatientId}`, null, null);
}
function* fetchPatientOrdersById(action) {
  try {
    yield put(showLoader(true));
    const { data } = yield call(fetchPatientOrdersByIdApi, action.payload.patientId);
    yield put(showLoader(false));
    yield put(getPatientOrdersByIdSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchPatientOrdersByIdSaga() {
  yield takeLatest(getPatientOrdersById.type, fetchPatientOrdersById);
}

function fetchPatientDiagnosisByIdApi({ chrPatientId, appointmentId }) {
  return phrApi('get', `patient_diagnosis/appointment/${appointmentId}/patient/${chrPatientId}`, null, null);
}
function* fetchPatientDiagnosisById(action) {
  try {
    yield put(showLoader(true));
    const { data } = yield call(fetchPatientDiagnosisByIdApi, action.payload.data);
    yield put(showLoader(false));
    yield put(getPatientDiagnosisByIdSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchPatientDiagnosisByIdSaga() {
  yield takeLatest(getPatientDiagnosisById.type, fetchPatientDiagnosisById);
}

function fetchAppointmentOrdersByIdApi(appointmentId) {
  return chrApi('get', `rx_order/appointment/${appointmentId}`, null, null);
}
function* fetchAppointmentOrdersById(action) {
  try {
    yield put(showLoader(true));
    const { data } = yield call(fetchAppointmentOrdersByIdApi, action.payload.appointmentId);
    yield put(showLoader(false));
    yield put(geAppointmentOrdersByIdSuccess({ data }));
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchAppointmentOrdersByIdSaga() {
  yield takeLatest(geAppointmentOrdersById.type, fetchAppointmentOrdersById);
}
